import axios, { AxiosInstance } from 'axios';
import { requestInterceptor, responseErrorInterceptor } from './interceptors';
import { ENV } from '../config/environment';

export const apiClient: AxiosInstance = axios.create({
  baseURL: ENV.API_BASE_URL,
  timeout: 15000,
  headers: {
    'Accept': 'application/json',
  },
});

// Backward-compatible named export used by the query hooks.
export const client = apiClient;

// Setup Interceptors
apiClient.interceptors.request.use(requestInterceptor);
apiClient.interceptors.response.use(
  (response) => response,
  responseErrorInterceptor
);

export default apiClient;
